import script from "./DonatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./DonatePage.vue?vue&type=script&setup=true&lang=js"

import "./DonatePage.vue?vue&type=style&index=0&id=d1374cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1374cec"]])

export default __exports__